import { ShareButton, type ShareButtonProps } from "components/tooltip-triggers";

export function Share(props: ShareButtonProps) {
  return <ShareButton {...props} />;
}
